export default __webpack_public_path__ + "static/media/dimitard_m.f81d15d1.jpg";